import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import AllDeals from "./AllDeals";
import ActiveDeals from "./ActiveDealsNew";
import { useLocation } from "react-router";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../../constants/AppConstants";
const DealsNew = () => {
  const { getUserPermission:activeRewardsPermissions} = usePermissionGetter(
    permissionsConstants.rewards,
    permissionsConstants.active_rewards
  );
  const { getUserPermission:allRewardsPermissions} = usePermissionGetter(
    permissionsConstants.rewards,
    permissionsConstants.all_rewards
  );
  const [tab, setTab] = useState('allRewards');
  const [tabList, setTabList] = useState<string[]>([]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  const { search } = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const tabId = query.get("tab");
    if (tabId) setTab(tabId);
  }, []);

useEffect(() => {
  if (allRewardsPermissions("read") && !tabList.includes("allRewards")) {
    setTabList((prevTabList) => [...prevTabList, "allRewards"]);
  }
  if (activeRewardsPermissions("read") && !tabList.includes("activeRewards")) {
    setTabList((prevTabList) => [...prevTabList, "activeRewards"]);
  }
}, [allRewardsPermissions, activeRewardsPermissions]);

  useEffect(() => {
    if (tabList[0] !== undefined && tab !== tabList[0]) setTab(tabList[0]);
  }, [tabList]);

  return (
    <Grid sx={{ background: theme.color?.background, borderRadius: "16px" }}>
      <Grid borderBottom={theme.border?.smallGrey} px={4} py={5}>
        <Typography
          sx={{
            fontWeight: theme.font?.fontWeight.thick,
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
          }}
        >
          Rewards
        </Typography>
      </Grid>
      <Grid
        item
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        sx={{ background: theme.color?.background, width: "100%" }}
      >
        <Box ml={3}>
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: theme.color?.secondary,
              },
            }}
            value={tab}
            onChange={handleChange}
            aria-label="tabs menu"
          >
            {allRewardsPermissions("read") && (
              <Tab
                value={"allRewards"}
                id={"allRewards"}
                label="All Rewards"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "allRewards" ? theme.color?.secondary : undefined,
                }}
              />
            )}
            {activeRewardsPermissions("read") && (
              <Tab
                value={"activeRewards"}
                id={"activeRewards"}
                label="Active Rewards"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "activeRewards"
                      ? theme.color?.secondary
                      : undefined,
                }}
              />
            )}
          </Tabs>
        </Box>
      </Grid>

      <Grid px={4} py={2}>
        {tab === "allRewards" ? <AllDeals /> : <ActiveDeals />}
      </Grid>
    </Grid>
  );
};

export default DealsNew;
